module.exports = __webpack_public_path__ + "media/images/eyecatch-submittion-f0d4a2efbc9e39ba7c1719a969f0ccbf.svg";